<template>
  <div class="home small-container" v-if="current">
    <h5><img :src="current.icone"><span>{{ current.nome }}</span></h5>

    <router-link class="comprar btn block" :to="{name: 'bilhete-especial-comprar'}">+ comprar bilhete QR Code</router-link>

    <p>Limite de 10 bilhetes por compra.</p>

    <p>Antes de comprar seus bilhetes, acesse a página do {{ current.nome}} para conhecer as orientações de utilização e de embarque.</p>

    <router-link class="comprados btn block"  :to="{name: 'bilhete-especial-comprados'}">acessar bilhetes comprados</router-link>

    <a class="saber-mais btn block" @click="openExternal(current.linkSaibaMais, true)">
      <img src="../../assets/img/info-branca.png"/> saber mais sobre o {{ current.nome}}
    </a>
  </div>
</template>

<style lang="scss">
  @import url('./QRCode.scss');
</style>

<script>
import * as service from '../../services/qrcode.service';
import { baseUrl } from '../../helpers/helpers'
import { types } from '../../store';
export default {
  name: 'bilhete-especial',
  props: { },
  components: { },
  data() {
    return {
    }
  },
  methods:{
    openExternal: function(url, blank) {
      window.open(url, blank ? '_blank' : '_self');
    }
  },
  computed: {
    current() {
      return this.$store.state.qrcode_current || null;
    }
  },
  created(){
  },
  mounted() {
    if(!this.current) {
      service.getEventoAtivo().then(res => {
        let icone = `${ baseUrl }/getimages/${res.data.icone.path}`
        res.data.icone = icone;
        console.log(res.data);
        this.$store.dispatch(types.SET_QRCODE_CURRENT, res.data);
      }).catch(() => {
        this.$router.push({ name: 'home' });
      });
    }
  }
}
</script>
